<mat-dialog-content>
  <div class="jobs-header">
    <h3>{{ 'Jobs' | translate }}</h3>

    <div class="badges">
      <div
        class="job-badge running"
        [matTooltip]="'Active' | translate"
      >
        <span class="job-badge-count">{{ runningJobsCount$ | async }}</span>
        <ix-icon name="sync" class="job-icon-running"></ix-icon>
      </div>
      <div
        class="job-badge waiting"
        [matTooltip]="'Waiting' | translate"
      >
        <span class="job-badge-count">{{ waitingJobsCount$ | async }}</span>
        <ix-icon name="schedule" class="job-icon-waiting"></ix-icon>
      </div>
      <div
        class="job-badge failed"
        [matTooltip]="'Failed' | translate"
      >
        <span class="job-badge-count">{{ failedJobsCount$ | async }}</span>
        <ix-icon name="cancel" class="job-icon-failed"></ix-icon>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading$ | async; else loaded">
    <mat-progress-bar
      class="loading-indicator"
      color="primary"
      mode="indeterminate"
    ></mat-progress-bar>
  </div>

  <div *ngIf="error$ | async as error" class="error">
    <ix-icon name="cancel" class="icon" color="accent"></ix-icon>
    <h4 class="message">
      <span class="error-word">{{ 'Error' | translate }}:</span>
      {{ error }}
    </h4>
  </div>

  <ng-template #loaded>
    <div *appLet="availableJobs$ | async as jobs">
      <div *ngIf="jobs.length > 0" class="jobs-list">
        <ix-job-item
          *ngFor="let job of jobs; trackBy: trackByJobId"
          [job]="job"
          [clickable]="true"
          (aborted)="onAbort(job)"
          (opened)="openEntityJobDialog(job)"
        ></ix-job-item>
      </div>

      <div *ngIf="!jobs.length" class="no-jobs">
        <ix-icon name="info"></ix-icon>
        <h4 class="message">{{ 'There are no tasks.' | translate }}</h4>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    ixTest="history"
    (click)="goToJobs()"
  >
    {{ 'History' | translate }}
  </button>
</mat-dialog-actions>
